export const VERIFY_IDENTITY = '/verify-your-identity';
export const VERIFY_IDENTITY_FAILED = '/verify-your-identity/failed';
export const RESIDENCY = '/residency';
export const OVERVIEW = '/account/overview';
export const FUNDING = '/account/funding';
export const FUNDING_DEPOSIT = '/account/deposit';
export const FUNDING_WITHDRAW = '/account/withdraw';
export const MY_INVESTMENTS = '/account/my-investments';
export const PRIMARY_MARKET = '/account/invest/primarymarket';

export const SETTINGS = '/settings';
export const FORGOT_PASSWORD = '/recover-password';

export const REGISTER = '/register';
export const LOGIN2FA = '/login/2fa';
export const LOGIN_OTP = '/login/otp';


export const VERIFY2FA = '/settings/2fa';

export const KYC = '/account/questionnaire/kyc';

export const AML = '/account/questionnaire/aml';
export const QUESTIONNAIRE_SUCCESS = '/account/questionnaire/success';

export const PIECE_OF_NEWS = (id: string) => `/account/news/${id}`;
export const NEWS = '/account/news';
